import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITagResource } from "../types";

export type ITagTranslationUpdateMutationParameters = {
    title: string;
    tag: RelationalValue<ITagResource>;
    locale: string;
};

export type ITagTranslationUpdateMutationResult = ITagResource;

export const tagTranslationUpdateMutation: IApiMutationFunction<ITagTranslationUpdateMutationParameters> = ({
    tag,
    title,
    locale,
}) => {
    return {
        method: "PUT",
        url: `/tags/${mapRelationalValue(tag)}`,
        data: {
            title,
        },
        headers: {
            "x-locale": locale,
        },
    };
};

export const useTagTranslationUpdateMutation = createApiMutationHook<
    ITagTranslationUpdateMutationParameters,
    ITagTranslationUpdateMutationResult
>(tagTranslationUpdateMutation);
